var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common-container" }, [
    _c("div", { staticClass: "search-container" }, [
      _c(
        "div",
        {
          staticStyle: {
            "box-shadow": "0 2px 12px 0 rgba(0, 0, 0, 0.1)",
            "margin-top": "-22px",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "25px" } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "70px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("portContacts.type"),
                        prop: "issueTypeName",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: _vm.$t("portContacts.type") },
                          model: {
                            value: _vm.form.issueTypeName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "issueTypeName", $$v)
                            },
                            expression: "form.issueTypeName",
                          },
                        },
                        _vm._l(_vm.issueTypeList, function (item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: {
                              label: _vm.isCnLang ? item.label : item.labelEn,
                              value: item.value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("portContacts.issueDescription"),
                        prop: "issueDescription",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 8, maxRows: 16 },
                        },
                        model: {
                          value: _vm.form.issueDescription,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "issueDescription", $$v)
                          },
                          expression: "form.issueDescription",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        border: "1px dashed #b3d8ff",
                        "margin-left": "70px",
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticStyle: {
                            padding: "10px",
                            "text-align": "center",
                          },
                          attrs: {
                            drag: "",
                            multiple: "",
                            headers: _vm.headers,
                            accept: ".jpeg,.jpg,.png,",
                            action: "",
                            "http-request": function (file) {
                              return _vm.uploadFile(file)
                            },
                            "on-remove": _vm.handleFileRemove,
                            "on-success": _vm.handlePhotoSuccess,
                            "on-change": _vm.handlePhotoChange,
                            "before-upload": _vm.beforeAvatarUpload,
                            "list-type": "picture-card",
                            "file-list": _vm.fileList,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "file",
                              fn: function (ref) {
                                var file = ref.file
                                return _c(
                                  "div",
                                  {},
                                  [
                                    _c("el-image", {
                                      staticClass:
                                        "el-upload-list__item-thumbnail",
                                      staticStyle: {
                                        "max-width": "150px",
                                        "max-height": "150px",
                                      },
                                      attrs: { src: file.url },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-actions",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-preview",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handlePictureCardPreview(
                                                  file
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-zoom-in",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.disabled
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-delete",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handlePhotoRemove(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              },
                            },
                          ]),
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-upload",
                            staticStyle: { color: "#409EFF" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dialog",
                        {
                          attrs: { visible: _vm.dialogVisible },
                          on: {
                            "update:visible": function ($event) {
                              _vm.dialogVisible = $event
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.dialogImageUrl,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-left": "60px",
                        "padding-top": "10px",
                        "font-size": "12px",
                        color: "#606266",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("portContacts.photoTips")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticStyle: {
                        "margin-left": "60px",
                        "margin-top": "10px",
                        width: "50%",
                      },
                      attrs: {
                        multiple: "",
                        headers: _vm.headers,
                        accept: ".xls,.xlsx,.doc,.pdf,.docx",
                        action: "",
                        "http-request": function (file) {
                          return _vm.uploadFile1(file)
                        },
                        "on-success": _vm.handleFileSuccess,
                        "on-change": _vm.handleFileChange,
                        "on-remove": _vm.handleFileRemove,
                        "before-remove": _vm.beforeRemove,
                        "before-upload": _vm.beforeFileUpload,
                        "file-list": _vm.fileList1,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v(_vm._s(_vm.$t("portContacts.attachFile")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v(_vm._s(_vm.$t("portContacts.fileTips")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { float: "right", "margin-top": "10px" },
                          attrs: { type: "success" },
                          on: { click: _vm.createIssue },
                        },
                        [_vm._v(_vm._s(_vm.$t("portContacts.createIssue")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("img", { staticClass: "avatar", attrs: { id: "avatar" } }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }